import { Component } from '@angular/core';

@Component({
  selector: 'app-tiktok-icon',
  templateUrl: 'tiktok-icon.component.svg',
})
export class TiktokIconComponent {
}

